<template>
  <div class="app-bank-account-information">
    <slot name="txtBefore"></slot>

    <b-row class="bank-account-owner">
      <b-col cols="12" md=""><label>
        <slot name="lblOwner">Kontoinhaber</slot>
      </label></b-col>
      <b-col md="" sm="12" class="value">{{customer.firstName}} {{customer.lastName}}</b-col>
    </b-row>

    <b-row class="bank-account-iban">
      <b-col cols="12" md=""><label>
        <slot name="lblIban">IBAN</slot>
      </label></b-col>
      <b-col cols="12" md="">
        <span v-if="isFullIban" class="bank-account-value">{{ bankAccount.iban }}</span>
        <span v-else class="bank-account-value">
          <span class="iban-number-block" :key="i" v-for="i in 3">****</span>
          <span class="iban-number-block">{{ bankAccount.iban }}</span>
        </span>
      </b-col>
    </b-row>

    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import { BCol, BRow } from 'bootstrap-vue'

const shortendIbanLength = 4

export default {
  name: 'BankAccountInformation',
  computed: {
    isFullIban: function () {
      // sometimes we know the full iban - e.g. when captured during the process
      // then we can fully show it.
      // in another case, we receive it from a backend - and only get the last 4 digits
      // then we have to fill the first places with asterisks to make it look nice
      return this.bankAccount.iban.length !== shortendIbanLength
    }
  },
  props: {
    bankAccount: {
      type: Object
    },
    customer: {
      type: Object
    }
  },
  components: {
    BRow,
    BCol
  }
}
</script>
